import { Tooltip, Toggle, ToggleProps } from '@cronos-labs/tectonic-ui-kit';
import clsx from 'clsx';
export interface AsCollateralToggleProps {
  disabled?: boolean;
  isEnabled: boolean;
  onClick: ToggleProps['onClick'];
  tooltipMessage?: string | null;
}

function AsCollateralToggle({
  disabled,
  isEnabled,
  onClick,
  tooltipMessage,
}: AsCollateralToggleProps): JSX.Element {
  if (tooltipMessage) {
    return (
      <Tooltip className="text-left" message={tooltipMessage}>
        <Toggle
          className={clsx({
            'cursor-not-allowed': disabled,
          })}
          checked={isEnabled}
          disabled={disabled}
          onClick={onClick}
          theme="yellow"
        />
      </Tooltip>
    );
  }

  return (
    <Toggle
      className={clsx({
        'cursor-not-allowed': disabled,
      })}
      checked={isEnabled}
      disabled={disabled}
      theme="yellow"
      onClick={onClick}
    />
  );
}

export default AsCollateralToggle;
